import { Reducer } from 'redux';

import { Action, createAction } from '../../../store/actionUtils';

export interface UIState {
    selectedLetter: string;
}

export enum UIActionTypes {
    SELECT_LETTER = 'ShowsIndex/ui/SELECT_LETTER',
}

export type SelectLetterAction = Action<UIActionTypes.SELECT_LETTER, string>;

const initialState: UIState = {
    selectedLetter: '',
};

const uiReducer: Reducer<UIState, SelectLetterAction> = (state = initialState, action) => {
    switch (action.type) {
        case UIActionTypes.SELECT_LETTER:
            return {
                ...state,
                selectedLetter: action.payload === state.selectedLetter ? '' : action.payload,
            };
        default:
            return state;
    }
};

// Action creators
export const selectLetter = createAction<SelectLetterAction>(UIActionTypes.SELECT_LETTER);

export default uiReducer;
